<template>
   <div id="loader_wrapper">
      <van-loading type="spinner" color="#fff" size="40" vertical>{{ $store.state.loadingText?$store.state.loadingText:'加载中...' }}</van-loading>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
  }
}
</script>
<style scoped>
#loader_wrapper{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: rgba(0, 0, 0,.8);
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
}
</style>